<template>
  <div>
    <div class="corzo-page-title-wrap corzo-style-custom corzo-left-align">
      <div class="corzo-header-transparent-substitute"></div>
      <div class="corzo-page-title-overlay"></div>
      <div class="corzo-page-title-container corzo-container">
        <div class="corzo-page-title-content corzo-item-pdlr">
          <div class="corzo-page-caption">匯德服务</div>
          <h1 class="corzo-page-title"></h1>
          <div class="corzo-page-caption-divider"></div>
        </div>
      </div>
    </div>
    <div class="corzo-page-wrapper" id="corzo-page-wrapper">
      <div class="gdlr-core-page-builder-body">
        <div class="gdlr-core-pbf-wrapper" style="padding: 80px 0px 30px 0px;" id="gdlr-core-wrapper-1">
          <div class="gdlr-core-pbf-background-wrap">
<!--            <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"-->
<!--                 style="background-image: url(static/upload/about2-bg.png); background-repeat: no-repeat; background-position: top center;"-->
<!--                 data-parallax-speed="0"></div>-->
          </div>
          <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
            <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
              <div class="gdlr-core-pbf-column gdlr-core-column-15 gdlr-core-column-first" data-skin="Service Skin"
                   id="gdlr-core-column-58332">
                <div class="gdlr-core-pbf-column-content-margin gdlr-core-js">
                  <div class="gdlr-core-pbf-background-wrap"></div>
                  <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                    <div class="gdlr-core-pbf-element">
                      <div
                        class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr">
                        <div class="gdlr-core-title-item-title-wrap">
                          <h3 class="gdlr-core-title-item-title gdlr-core-skin-title"
                              style="font-size: 48px; font-weight: 300; letter-spacing: 0px; text-transform: none; color: #d32525;">
                            匯德服务<span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div class="gdlr-core-pbf-element">
                      <div class="gdlr-core-custom-menu-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-style-2"
                           style="padding-bottom: 15px; font-size: 19px;">
                        <ul id="menu-services" class="menu">
                          <li class="menu-item"><a href="#/services/5">升学易</a></li>
                          <li class="menu-item"><a href="#/services/1">离岸家族服务</a></li>
                          <li class="menu-item"><a href="#/services/2">跨境企业服务</a></li>
                          <li class="menu-item"><a href="#/services/3">离岸资产配置</a></li>
                          <li class="menu-item"><a href="#/services/4">海外家族办公室设立</a></li>
                        </ul>
                      </div>
                    </div>
                    <div class="gdlr-core-pbf-element">
                      <div
                        class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-left-align"
                        style="margin-bottom: 45px;">
                        <div class="gdlr-core-divider-container" style="max-width: 80px;">
                          <div class="gdlr-core-divider-line gdlr-core-skin-divider"
                               style="border-color: #d32525; border-width: 2px;"></div>
                        </div>
                      </div>
                    </div>
                    <div class="gdlr-core-pbf-element">
                      <div class="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align">
                        <!--                        <a-->
                        <!--                          class="gdlr-core-button gdlr-core-button-gradient gdlr-core-left-align gdlr-core-button-no-border gdlr-core-button-full-width"-->
                        <!--                          href="#" style="-->
                        <!--                                                                font-size: 18px;-->
                        <!--                                                                font-weight: 500;-->
                        <!--                                                                letter-spacing: 0px;-->
                        <!--                                                                color: #d32525;-->
                        <!--                                                                padding: 15px 35px 15px 35px;-->
                        <!--                                                                text-transform: none;-->
                        <!--                                                                border-radius: 1px;-->
                        <!--                                                                -moz-border-radius: 1px;-->
                        <!--                                                                -webkit-border-radius: 1px;-->
                        <!--                                                                background: #f5f5f5;-->
                        <!--                                                            ">-->
                        <!--                          <i class="gdlr-core-pos-left fa fa-file-pdf-o"-->
                        <!--                             style="font-size: 16px; color: #d32525;"></i><span-->
                        <!--                          class="gdlr-core-content">Download PDF</span>-->
                        <!--                        </a>-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="gdlr-core-pbf-column gdlr-core-column-45" id="gdlr-core-column-98149">
                <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="padding: 10px 0px 0px 20px;">
                  <div class="gdlr-core-pbf-background-wrap"></div>
                  <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                    <div class="gdlr-core-pbf-element">
                      <div
                        class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                        style="padding-bottom: 20px;">
                        <span
                          class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                          style="font-size: 14px; font-weight: 500; font-style: normal; letter-spacing: 3px; text-transform: uppercase; color: #d32525;">
                           <span class="gdlr-core-title-item-left-dot"
                                 style="width: 5px; height: 5px; background-color: #d32525; margin-right: 15px;"></span>
                          {{ subTitle }}
                        </span>
                        <div class="gdlr-core-title-item-title-wrap">
                          <h3 class="gdlr-core-title-item-title gdlr-core-skin-title"
                              style="font-size: 44px; font-weight: 500; letter-spacing: 0px; text-transform: none; color: #353535;">
                            {{ title }}
                            <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div class="gdlr-core-pbf-element">
                      <div
                        class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align gdlr-core-no-p-space"
                        style="padding-bottom: 40px;">
                        <div class="gdlr-core-text-box-item-content"
                             style="font-size: 23px; font-weight: 400; letter-spacing: 0px; text-transform: none; color: #353535;">
                          <p v-if="type === '1'">

                          </p>
                          <p v-else-if="type === '2'">
                            跨境架构搭建服务、境内企业出境投资(ODI)登记服务、员工股权激励计划(ESOP)方案设计服务
                          </p>
                          <p v-else-if="type === '3'">
                            目前，超过60%的中国高净值人群配置了海外资产。中国高净值人群可投资资产中，境外投资金额占总资产金额的30%以上。中国高净值人群配置海外资产的主要动因来自于分散风险，增强收益以及资金使用等需求。
                          </p>
                          <p v-else-if="type === '5'">
                            子女多一个“港籍生”身份 多一个“优质升学”的机会
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="gdlr-core-pbf-element">
                      <div
                        class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-left-align"
                        style="margin-bottom: 40px;">
                        <div class="gdlr-core-divider-container" style="max-width: 120px;">
                          <div class="gdlr-core-divider-line gdlr-core-skin-divider"
                               style="border-color: #e8e8e8; border-width: 3px;"></div>
                        </div>
                      </div>
                    </div>
                    <div class="gdlr-core-pbf-element">
                      <div
                        class="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align gdlr-core-no-p-space"
                        style="padding-bottom: 40px;">
                        <div class="gdlr-core-text-box-item-content"
                             style="font-size: 18px; font-weight: 400; letter-spacing: 0px; text-transform: none; color: #525252;">
                          <div v-if="type === '1'">
                            <p>
                              离岸信托多为海外信托机构受个人或家族的委托，代为管理、处置家庭财产的财产管理方式，以实现富人的财富规划及传承目标，最早出现在长达25年经济繁荣期(1982年到2007年，被称为美国第二个镀金年代)后的美国。
                            </p>
                          </div>
                          <div v-if="type === '4'">
                            <p>专为富有家庭提供全方位财富管理和家族服务的机构，以实现家族资产的长期发展为目标，使其能够顺利地跨代传承和保值增值。</p>
                            <br/>
                            <p>家族办公室的业务范围往往包含资产管理、遗产规划、投资移民、日常财务、企业管理、上市咨询等。可以为整个家族解决金融、税务、法务、移民等多种问题。</p>
                          </div>
                          <div v-if="type === '5'">
                            <p>香港是世界级教育和培训的枢纽，同时又根植于中国文化，学校类型十分多样。香港的教育政策，一直向前改进，培养学生独立思考的能力及多元化的技能，兼具国际视野。
                            </p>
                            <br/>
                            <p>近两年香港政府通过多项利好政策吸引内地及世界各地的优秀人才，且经港府认可的获得香港人才的家庭，子女可以跟随父母赴港生活并学习。</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="gdlr-core-pbf-element" v-if="type === '0'">
                      <div class="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-left-align gdlr-core-item-pdlr"
                           style="padding-bottom: 0px;">
                        <div
                          class="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle"
                          style="border-width: 0px; max-width: 372px;">
                          <img src="static/upload/icon-img002-1.png" alt="" width="800" height="245"
                               title="icon img002">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 经验优势 -->
        <ServiceContent1 v-if="type === '1'"></ServiceContent1>
        <ServiceContent2 v-else-if="type === '2'"></ServiceContent2>
        <ServiceContent3 v-else-if="type === '3'"></ServiceContent3>
        <ServiceContent4 v-else-if="type === '4'"></ServiceContent4>
        <ServiceContent5 v-else-if="type === '5'"></ServiceContent5>

        <!-- 订阅 -->
<!--        <div class="gdlr-core-pbf-wrapper" style="padding: 0px 0px 0px 0px;">-->
<!--          <div class="gdlr-core-pbf-background-wrap">-->
<!--            <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"-->
<!--                 style="background-image: url(static/upload/SVC-bg-black.jpg); background-size: cover; background-position: center;"-->
<!--                 data-parallax-speed="0"></div>-->
<!--          </div>-->
<!--          <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">-->
<!--            <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">-->
<!--              <div class="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" id="gdlr-core-column-36170">-->
<!--                <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="padding: 165px 0px 155px 0px;">-->
<!--                  <div class="gdlr-core-pbf-background-wrap"></div>-->
<!--                  <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js" style="max-width: 750px;">-->
<!--                    <div class="gdlr-core-pbf-element">-->
<!--                      <div-->
<!--                        class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align"-->
<!--                        style="margin-bottom: 70px;">-->
<!--                        <div class="gdlr-core-divider-container" style="max-width: 180px;">-->
<!--                          <div class="gdlr-core-divider-line gdlr-core-skin-divider"-->
<!--                               style="border-color: #d5d5d5;"></div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="gdlr-core-pbf-element">-->
<!--                      <div-->
<!--                        class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"-->
<!--                        style="padding-bottom: 40px;">-->
<!--                        <div class="gdlr-core-title-item-title-wrap">-->
<!--                          <h3 class="gdlr-core-title-item-title gdlr-core-skin-title"-->
<!--                              style="font-size: 37px; font-weight: 600; letter-spacing: 0px; text-transform: none; color: #ffffff;">-->
<!--                            匯信天下  托之有道<span-->
<!--                            class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>-->
<!--                          </h3>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="gdlr-core-pbf-element">-->
<!--                      <div class="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align"-->
<!--                           style="padding-bottom: 0px;">-->
<!--                        <a-->
<!--                          class="gdlr-core-button gdlr-core-button-gradient gdlr-core-center-align gdlr-core-button-no-border"-->
<!--                          href="#/contact" style="-->
<!--                                                                font-size: 16px;-->
<!--                                                                font-weight: 700;-->
<!--                                                                letter-spacing: 0px;-->
<!--                                                                color: #ffffff;-->
<!--                                                                padding: 3px 33px 3px 33px;-->
<!--                                                                text-transform: none;-->
<!--                                                                border-radius: 28px;-->
<!--                                                                -moz-border-radius: 28px;-->
<!--                                                                -webkit-border-radius: 28px;-->
<!--                                                                background: #d32525;-->
<!--                                                            ">-->
<!--                          <span class="gdlr-core-content">联系我们</span><i-->
<!--                          class="gdlr-core-pos-right ion-ios-arrow-thin-right"-->
<!--                          style="font-size: 31px; color: #ffffff;"></i>-->
<!--                        </a>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

        <!-- 分割线 -->
        <div class="gdlr-core-pbf-section">
          <div class="gdlr-core-pbf-section-container gdlr-core-container clearfix">
            <div class="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" id="gdlr-core-column-60251" style="z-index: 9;">
              <div class="gdlr-core-pbf-column-content-margin gdlr-core-js" style="margin: -45px 0px -65px 0px; padding: 0px 0px 0px 0px;">
                <div class="gdlr-core-pbf-background-wrap"></div>
                <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                  <div class="gdlr-core-pbf-element">
                    <div class="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-center-align" style="margin-bottom: 0px;">
                      <div class="gdlr-core-divider-container" style="max-width: 1px;"><div class="gdlr-core-divider-line gdlr-core-skin-divider" style="border-color: #d32525; border-width: 100px;"></div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import ServiceContent1 from './service/ServiceContent1'
import ServiceContent2 from './service/ServiceContent2'
import ServiceContent3 from './service/ServiceContent3'
import ServiceContent4 from './service/ServiceContent4'
import ServiceContent5 from './service/ServiceContent5'
export default {
  name: 'Services',
  components: {
    ServiceContent1,
    ServiceContent2,
    ServiceContent3,
    ServiceContent4,
    ServiceContent5
  },
  data () {
    return {
      type: '',
      title: '',
      subTitle: ''
    }
  },
  methods: {
    change () {
      this.type = this.$route.params.type
      this.getType()
    },
    getType () {
      switch (parseInt(this.type)) {
        case 1:
          this.subTitle = 'Offshore Family Services'
          this.title = '离岸家族服务'
          break

        case 2:
          this.subTitle = 'Cross Border Enterprise Services'
          this.title = '跨境企业服务'
          break

        case 3:
          this.subTitle = 'Offshore Asset Allocation Consulting'
          this.title = '离岸资产配置咨询'
          break

        case 4:
          this.subTitle = 'Overseas Family Office Set Up'
          this.title = '海外家族办公室设立'
          break

        case 5:
          this.subTitle = 'Study'
          this.title = '升学易'
          break
      }
    }
  },
  mounted () {
    this.change()
  },
  watch: {
    $route: 'change'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Services.vue